/* eslint-disable no-restricted-imports */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import { Warning as WarningIcon } from '@material-ui/icons';

export function CancelFulfillmentDialog({ open, onClose, onConfirm, fulfillment }) {
  if (!fulfillment) return null;

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <WarningIcon color='error' />
          Cancelar Atendimento
        </div>
      </DialogTitle>
      <DialogContent>
        <Typography gutterBottom>Tem certeza que deseja cancelar este atendimento?</Typography>

        <Typography
          variant='body2'
          style={{ marginTop: 16, padding: 12, backgroundColor: '#E3F2FD', borderRadius: 4 }}
        >
          <strong>Produto:</strong> {fulfillment.item?.part_number}
          <br />
          <strong>Descrição:</strong> {fulfillment.item?.description}
          <br />
          <strong>Delivery:</strong> {fulfillment.delivery}
          <br />
          <strong>Quantidade:</strong> {fulfillment.quantity} un.
          <br />
          <strong>Local:</strong> {fulfillment.location}
        </Typography>

        <Typography variant='body2' color='textSecondary' style={{ marginTop: 16 }}>
          <strong>O que será feito:</strong>
        </Typography>
        <Typography component='div' variant='body2' color='textSecondary'>
          <ul style={{ marginTop: 8, paddingLeft: 20 }}>
            <li>O estoque será devolvido ao local de origem ({fulfillment.location})</li>
            <li>O atendimento será removido do pedido</li>
            <li>Você poderá atender novamente com outro estoque</li>
            <li>A ação será registrada no histórico</li>
          </ul>
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Voltar</Button>
        <Button onClick={onConfirm} color='secondary' variant='contained'>
          Confirmar Cancelamento
        </Button>
      </DialogActions>
    </Dialog>
  );
}
